export const common = {
  // Navigation
  "nav.home": "Laman Utama",
  "nav.about": "Tentang Kami",
  "nav.services": "Perkhidmatan", 
  "nav.products": "Produk",
  "nav.certifications": "Pensijilan",
  "nav.partnerships": "Perkongsian",
  "nav.contact": "Hubungi",
  "nav.quote": "Dapatkan Sebut Harga",
  
  // Common buttons
  "button.learnMore": "Ketahui Lebih Lanjut",
  "button.getQuote": "Dapatkan Sebut Harga", 
  "button.contactUs": "Hubungi Kami",
  "button.viewAll": "Lihat Semua",
  "button.download": "Muat Turun",
  
  // Common text
  "company.name": "KUMPULAN DRIXEM",
  "company.tagline": "Pakar Minyak Kelapa Sawit Malaysia",
  "language.current": "Bahasa Malaysia"
};

export default common;